import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { startPosIdentSession } from '../../../app/thunks/start-pos-ident-session';
import { selectPhotoIdentRequired } from '../../../app/slices/flags.slice';
import { ReactComponent as PhotoIdentLogo } from '../../../assets/images/PhotoIdentLogoNoText.svg';
import { useAppTranslation } from '../../../i18n';
import IdentificationMethodCard from './IdentificationMethodCard';

const TRANSLATION_PREFIX = 'steps.bank-auth-type-selection';

export const PhotoIdentButton = () => {
	const { t } = useAppTranslation();
	const dispatch = useAppDispatch();
	const required = useAppSelector(selectPhotoIdentRequired);
	const [submitting, setSubmitting] = useState<boolean>(false);

	const onClickPhotoIdent = async () => {
		try {
			setSubmitting(true);
			await dispatch(startPosIdentSession());
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<IdentificationMethodCard
			id="photo-ident-auth"
			icon={<PhotoIdentLogo className="w-11 h-11" />}
			title={t(`${TRANSLATION_PREFIX}.photo-ident-title`)}
			description={t(`${TRANSLATION_PREFIX}.photo-ident-description`)}
			trustText={t(`${TRANSLATION_PREFIX}.photo-ident-trust`)}
			onClick={onClickPhotoIdent}
			disabled={submitting}
			required={required}
		/>
	);
};

export default PhotoIdentButton;
